var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyIcon = function SvgEmptyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 22C19.7789 22 22.1667 19.6122 22.1667 16.6667C22.1667 13.7212 19.7789 11.3334 16.8333 11.3334C13.8878 11.3334 11.5 13.7212 11.5 16.6667C11.5 19.6122 13.8878 22 16.8333 22Z",
    fill: "#55B8B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833344 3.33335C0.833344 1.86059 2.02725 0.666687 3.50001 0.666687H51.5C52.9728 0.666687 54.1667 1.86059 54.1667 3.33335V40.6667C54.1667 42.1394 52.9728 43.3334 51.5 43.3334H3.50001C2.02725 43.3334 0.833344 42.1394 0.833344 40.6667V3.33335ZM6.16668 6.00002V38H13.0621L28.2811 22.7811C29.3225 21.7397 31.0109 21.7397 32.0523 22.7811L35.5 26.2288L48.8333 12.8955V6.00002H6.16668ZM48.8333 38H20.6046L30.1667 28.4379L33.6144 31.8856C34.6558 32.927 36.3443 32.927 37.3857 31.8856L48.8333 20.438V38Z",
    fill: "#55B8B3"
  })));
};
export { SvgEmptyIcon as ReactComponent };
export default __webpack_public_path__ + "assets/e2891761.svg";